import { bl_fi_nsti_stock_attachment_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class NstiStockAttachmentContainerModel extends BaseContainerModel {
  bl_fi_nsti_stock_attachment: bl_fi_nsti_stock_attachment_RowClass = new bl_fi_nsti_stock_attachment_RowClass();
}
